
<script>
import PageSidebar from '@/components/sidebar/PageSidebar'
import MobileSidebar from '@/components/sidebar/MobileSidebar'
import { sidebarWidth } from '@/components/sidebar/state'

import { useRoute } from 'vue-router';
import { computed, watch } from 'vue'

export default {
  name: 'App',
  components: {
    PageSidebar,
    MobileSidebar
  },
  setup() {
    const route = useRoute();
    const hideShell = computed(() => route.meta.hideShell === true)

    watch(
        () => route.path,
        (path) => {
          document.body.classList.toggle('mpos', path.startsWith('/mpos'))
        },
        { immediate: true }
    )

      return { sidebarWidth, route, hideShell }
  }
 /* created () {
    this.$store.dispatch('AutoLogin')
  }*/
}

</script>

<template>
  <router-view v-if="hideShell" />
  <template v-else>
  <MobileSidebar v-if="route.path.startsWith('/mpos')" />
  <PageSidebar v-else />
  <div class="main-section"
       :class="{ mpos: route.path.startsWith('/mpos') }" :style="{ 'margin-left': sidebarWidth }">
    <router-view />
  </div>
  </template>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;


  background: linear-gradient(175deg,#a5ddf7,#8ed4f5 50%,#30b0ed 0,#8ed4f5);
  background-attachment: fixed;
}

/* Global only for mpos layout */
.mpos #app {
  padding: 0;
}

#nav {
  padding: 30px;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #42b983;
}

@media screen and (max-width: 1024px) {
  .main-section {
    margin-left: inherit !important;
    margin-top: 20px;
  }
}
</style>
